// eslint-disable-next-line
// @ts-nocheck
import Tabs from '../components/tabs';
import { favorites } from 'store';

const maxItemHeight = 32;

const showUnpinDialog = async (item, tabs) => {
	const confirmResult = await ArasModules.Dialog.confirm(
		aras.getResource('', 'common.itemtype_not_available'),
		{
			title: aras.getResource('', 'common.access_denied'),
			okButtonText: aras.getResource('', 'common.unpin'),
			okButtonModifier: 'aras-button_secondary'
		}
	);

	if (confirmResult === 'ok') {
		tabs.removeTab(item.id);
		try {
			await favorites.delete(item.id);
		} catch (e) {
			tabs.addTab(item.id, item);
		}
	}
};

export default class NavigationPanelTabs extends Tabs {
	usetooltip = true;
	vertical = true;

	tooltipSettings = {
		tooltipPosition: 'right'
	};
	state = {
		favorites: new Map()
	};

	#resizeHandler = (): Promise<void> => {
		return this.render();
	};

	connectedCallback() {
		super.connectedCallback();
		this.classList.add('aras-navigation-panel-tabs', 'aras-tabs_b');
		window.addEventListener('resize', this.#resizeHandler);
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this.#resizeHandler);
	}

	render() {
		const visibleItems = [];
		const maxVisibleItems = Math.max(
			Math.floor(this.clientHeight / maxItemHeight),
			1
		);

		this.state.favorites.forEach((item, id) => {
			if (visibleItems.length < maxVisibleItems) {
				visibleItems.push(id);
			}
		});
		this.tabs = visibleItems;
		this.data = this.state.favorites;

		return super.render();
	}

	selectTab(id) {
		const item = this.state.favorites.get(id);
		if (item.locked) {
			return showUnpinDialog(item, this);
		}

		return super.selectTab(id);
	}

	formatter(id, data) {
		const item = data.get(id);
		if (!item.locked) {
			return null;
		}

		const lockIconNode = <span className="aras-navigation-panel-tabs__lock" />;
		const imageNode = this._getImage(item.image);
		const content = [lockIconNode, imageNode];

		return this._getTooltipTemplate(item, content);
	}
}

NavigationPanelTabs.define('aras-navigation-panel-tabs');
